import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, ArrowRight } from 'lucide-react';

const LOGO = 'https://customer-assets.emergentagent.com/job_ec4780e0-2344-45fc-bbeb-d029795156a0/artifacts/umgw06wm_CreduceLogopng.png';

const Navigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    {
      name: 'About',
      path: '/about',
      hasDropdown: true,
      dropdown: [{ name: "Founder's Message", path: '/founders-message' }]
    },
    { name: 'Energy Certificates', path: '/energy-attribute-certificates' },
    { name: 'Services', path: '/services' },
    { name: 'Projects', path: '/projects' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-zinc-200" data-testid="main-navigation">
      <div className="container mx-auto">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center relative z-10" data-testid="nav-logo">
            <img src={LOGO} alt="Creduce Technologies" className="h-14 object-contain" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-9">
            {navLinks.map((link) => (
              link.hasDropdown ? (
                <div
                  key={link.path}
                  className="relative"
                  onMouseEnter={() => setIsAboutDropdownOpen(true)}
                  onMouseLeave={() => setIsAboutDropdownOpen(false)}
                >
                  <Link
                    to={link.path}
                    data-testid="nav-link-about"
                    className={`text-sm font-medium transition-colors flex items-center gap-1 pb-1 border-b-2 ${
                      isActive(link.path) || location.pathname.startsWith('/founders-message')
                        ? 'text-[#047857] border-[#047857]'
                        : 'text-[#52525B] border-transparent hover:text-[#047857]'
                    }`}
                  >
                    {link.name}
                    <ChevronDown className="w-4 h-4" />
                  </Link>
                  {isAboutDropdownOpen && (
                    <div className="absolute top-full left-0 pt-3 w-60 z-50">
                      <div className="bg-white border border-zinc-200 shadow-lg py-2">
                        {link.dropdown.map((item) => (
                          <Link
                            key={item.path}
                            to={item.path}
                            data-testid="nav-dropdown-founders"
                            className="block px-4 py-3 text-sm text-[#52525B] hover:bg-[#FAFAFA] hover:text-[#047857] transition-colors"
                          >
                            {item.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-link-${link.name.toLowerCase()}`}
                  className={`text-sm font-medium transition-colors pb-1 border-b-2 ${
                    isActive(link.path)
                      ? 'text-[#047857] border-[#047857]'
                      : 'text-[#52525B] border-transparent hover:text-[#047857]'
                  }`}
                >
                  {link.name}
                </Link>
              )
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-semibold text-white bg-[#047857] hover:bg-[#065F46] transition-colors"
              data-testid="nav-get-started-btn"
            >
              Get Started
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-[#09090B]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="nav-mobile-toggle"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-zinc-200" data-testid="nav-mobile-menu">
          <div className="container mx-auto py-4">
            {navLinks.map((link) => (
              <div key={link.path}>
                <Link
                  to={link.path}
                  onClick={() => !link.hasDropdown && setIsMobileMenuOpen(false)}
                  className={`block py-3 px-4 mb-1 transition-colors ${
                    isActive(link.path) ? 'bg-[#047857] text-white' : 'text-[#09090B] hover:bg-[#FAFAFA]'
                  }`}
                >
                  {link.name}
                </Link>
                {link.hasDropdown && link.dropdown.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="block py-2 px-8 text-sm mb-1 text-[#52525B] hover:bg-[#FAFAFA] hover:text-[#047857] transition-colors"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            ))}
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-center mt-4 px-6 py-3 text-sm font-semibold text-white bg-[#047857]"
            >
              Get Started
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
